import { ChevronsUpDownIcon } from "lucide-react"
import { useMemo } from "react"
import { Picker } from "@/design-system/index.ts"
import { Button } from "@/primitives/button.tsx"
import { browserTimeZone, timeZoneOptions, timeZoneShown } from "./describe.ts"

/**
 * A time zone, chosen from every zone IANA names by searching for its city, its region or its
 * offset, with the browser's own zone first.
 */
export function TimeZoneField({
  value,
  onChange,
}: {
  value: string | null
  onChange: (zone: string) => void
}) {
  const now = useMemo(() => new Date(), [])
  const options = useMemo(() => timeZoneOptions(now, browserTimeZone()), [now])
  return (
    <Picker
      mode="single"
      value={value}
      onChange={onChange}
      options={options}
      searchPlaceholder="Search time zones"
      width="md"
      trigger={
        <Button variant="outline" size="sm" className="w-72 justify-between font-normal">
          <span className="truncate">{timeZoneShown(value, now)}</span>
          <ChevronsUpDownIcon data-icon="inline-end" className="text-subtle-foreground" />
        </Button>
      }
    />
  )
}
